var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "export-a",
    d: "M.435.225h13.043v13.688H.435z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.478 .645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "export-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#export-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.661 6.087h1.686c.36 0 .652.292.652.652v5.87h3.913v-5.87c0-.36.292-.652.652-.652h1.688L6.955 1.792 2.661 6.087zm6.25 7.826H5c-.72 0-1.305-.585-1.305-1.304V7.39H1.087a.653.653 0 0 1-.461-1.113L6.494.408a.67.67 0 0 1 .923 0l5.87 5.87a.653.653 0 0 1-.461 1.113h-2.61v5.218c0 .719-.584 1.304-1.304 1.304z",
    mask: "url(#export-b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.913 19.775H1.957A1.959 1.959 0 0 1 0 17.818V15.21a.652.652 0 0 1 1.304 0v2.608c0 .36.293.653.653.653h16.956c.36 0 .652-.293.652-.653V15.21a.652.652 0 0 1 1.305 0v2.608c0 1.08-.879 1.957-1.957 1.957"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.ba5b20619d81c281ac88d60468cf2e39.svg";
export { ForwardRef as ReactComponent };